import React, { useState, useEffect } from "react";
import { Button, FormControl, InputAdornment, OutlinedInput, Grid, Checkbox, Dialog, DialogContent } from "@mui/material";
import { images, taskAssign } from "../../config/images";  // Assuming these images exist in your config
import translations from "../../config/language";
import { changePassword } from "../../config/services";
import { notifyError, notifySuccess } from "../../config/ToastMessage";

const ChangePasswordPopup = ({ isOpen, onClose, onConfirm, loading, setLoading, id }) => {


  const [formValues, setFormValues] = useState({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };


  const handleTogglePasswordVisibility = (field) => {
    if (field === "old") {
      setShowOldPassword(!showOldPassword);
    } else if (field === "new") {
      setShowNewPassword(!showNewPassword);
    } else if (field === "confirm") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  const [lengthValid, setLengthValid] = useState(false);
  const [numberValid, setNumberValid] = useState(false);
  const [specialCharValid, setSpecialCharValid] = useState(false);
  const [lowercaseValid, setLowercaseValid] = useState(false);
  const [uppercaseValid, setUppercaseValid] = useState(false);

  const language = process.env.REACT_APP_LANGUAGE;

  useEffect(() => {
    // Check password length

    if (
      formValues.newPassword.length >= 8 &&
      formValues.newPassword.length <= 16
    ) {
      setLengthValid(true);
    } else {
      setLengthValid(false);
    }

    // Check for number
    const numberRegex = /\d/;
    if (numberRegex.test(formValues.newPassword)) {
      setNumberValid(true);
    } else {
      setNumberValid(false);
    }

    // Check for special character
    const specialCharRegex = /[^\w\s]/;
    if (specialCharRegex.test(formValues.newPassword)) {
      setSpecialCharValid(true);
    } else {
      setSpecialCharValid(false);
    }

    // Check for lowercase letter
    const lowercaseRegex = /[a-z]/;
    if (lowercaseRegex.test(formValues.newPassword)) {
      setLowercaseValid(true);
    } else {
      setLowercaseValid(false);
    }

    // Check for uppercase letter
    const uppercaseRegex = /[A-Z]/;
    if (uppercaseRegex.test(formValues.newPassword)) {
      setUppercaseValid(true);
    } else {
      setUppercaseValid(false);
    }

  }, [formValues.newPassword]);



  const handleChangePassword = async () => {

    const password = formValues.newPassword;

    const lengthValid = password.length >= 8 && password.length <= 16;
    const numberValid = /\d/.test(password);
    const specialCharValid = /[^\w\s]/.test(password);
    const lowercaseValid = /[a-z]/.test(password);
    const uppercaseValid = /[A-Z]/.test(password);


    if (!formValues.newPassword) {
      notifyError(translations[language].pleaseEnterPassword);
      return true;
    }
    if (!formValues.confirmNewPassword) {
      notifyError(translations[language].pleaseReEnterPassword);
      return true;
    }

    if (
      !lengthValid ||
      !numberValid ||
      !specialCharValid ||
      !lowercaseValid ||
      !uppercaseValid
    ) {
       notifyError(translations[language].passwordValidation);
      return;
    }

    if (formValues.newPassword !== formValues.confirmNewPassword) {
      notifyError(translations[language].passwordMismatch);
      return;
    }
    const params = {
      old_password: formValues.oldPassword,
      new_password: formValues.newPassword,
      confirm_password: formValues.confirmNewPassword,
    }
    try {
      setLoading(true);

      const resp = await changePassword(id, params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
        sessionStorage.setItem("password", btoa(formValues.newPassword));
        handleClose();
        onConfirm();
      }

    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      handleClose();
    }


  };

  const handleClose = () => {
    setFormValues({
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    onClose();
  };

  // Return null if the popup is not open
  if (!isOpen) return null;

  return (
    <>
      <Dialog open={isOpen}
        maxWidth="xs"
        fullWidth
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <div className="assign-div">
          {" "}
          <div className="d-flex justify-content-around align-items-center">
            <h5
              className="p-3 mb-0"
              style={{ textAlign: "center", marginLeft: "70px" }}
            >
              {/* {translations} */}
              Change Password
            </h5>
            <img
              src={taskAssign.closeIcon}
              alt=""
              style={{
                height: "30px",
                width: "30px",
                cursor: "pointer",
                marginLeft: "95px",
              }}
              onClick={() => handleClose()}
            />
          </div>

        </div>
        <DialogContent>
          {/* Old Password Input */}
          <FormControl fullWidth className="mb-3" sx={{ m: 1 }} variant="outlined">
            <OutlinedInput
              id="old-password"
              type={showOldPassword ? 'text' : 'password'}
              value={formValues.oldPassword}
              onChange={handleChange}
              name="oldPassword"
              startAdornment={
                <InputAdornment position="start">
                  <img src={images.viewPassword} className="input-logo" alt="view" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <img
                    src={images.viewIcon}
                    onClick={() => handleTogglePasswordVisibility("old")}
                    className="input-logo"
                    style={{ cursor: "pointer" }}
                    alt="toggle visibility"
                  />
                </InputAdornment>
              }
              placeholder="Old Password"
            />
          </FormControl>

          {/* New Password Input */}
          <FormControl fullWidth className="mb-3" sx={{ m: 1 }} variant="outlined">
            <OutlinedInput
              id="new-password"
              type={showNewPassword ? 'text' : 'password'}
              value={formValues.newPassword}
              onChange={handleChange}
              name="newPassword"
              startAdornment={
                <InputAdornment position="start">
                  <img src={images.viewPassword} className="input-logo" alt="view" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <img
                    src={images.viewIcon}
                    onClick={() => handleTogglePasswordVisibility("new")}
                    className="input-logo"
                    style={{ cursor: "pointer" }}
                    alt="toggle visibility"
                  />
                </InputAdornment>
              }
              placeholder="New Password"
            />
          </FormControl>

          {/* Confirm New Password Input */}
          <FormControl fullWidth className="mb-3" sx={{ m: 1 }} variant="outlined">
            <OutlinedInput
              id="confirm-new-password"
              type={showConfirmPassword ? 'text' : 'password'}
              value={formValues.confirmNewPassword}
              onChange={handleChange}
              name="confirmNewPassword"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleChangePassword();
                }
              }}
              startAdornment={
                <InputAdornment position="start">
                  <img src={images.viewPassword} className="input-logo" alt="view" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <img
                    src={images.viewIcon}
                    onClick={() => handleTogglePasswordVisibility("confirm")}
                    className="input-logo"
                    style={{ cursor: "pointer" }}
                    alt="toggle visibility"
                  />
                </InputAdornment>
              }
              placeholder="Confirm New Password"
            />
          </FormControl>

          <button
            className="assign-task-button mt-2"
            onClick={() => handleChangePassword()}>
            {loading ? <span className="spinner"></span> : "Confirm"}
          </button>
        </DialogContent>

      </Dialog>
    </>
  );
};

export default ChangePasswordPopup;
